import React, { useState, useEffect } from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
import {
  Select,
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Checkbox,
} from "antd";
import AddModal from "@components/Modal";
import InspectionApi from "@api/inspectionnew";
import sysApi from "@api/sys";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const runStatusRange = [
  {
    label: "运行",
    value: "1",
  },
  {
    label: "热备",
    value: "0",
  },
];

const Option = Select.Option;
export default ({
  title,
  visible,
  formData = {},
  cancel,
  templateList = [],
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [defectslevelLs, setDefectslevelLs] = useState([]);
  const [tmpType, setTmpType] = useState();

  useEffect(() => {
    if (visible) {
      getDefectLevelLs();
      form.setFieldsValue({...formData,templateType:"0"});
      changeTmpType(0);
    }
  }, [visible]);

  const getDefectLevelLs = () => {
    InspectionApi.defectLevelLs({ pageNum: 1, pageSize: 10 }).then((res) => {
      if (res.status == 0 && res.data) {
        setDefectslevelLs(res.data);
      }
    });
  };

  // 提交
  const submit = () => {
    form.validateFields().then(async (values) => {
      if (!values) return;
      setLoading(true);
      let param = {
        ...values,
      };
      if (formData && formData.id) {
        param.id = formData.id;
        // 获取流程id
        const result = await sysApi.getFlowableId({
          dictType: "sw-flowable",
          dictKey: "patrol_template_updateInfo",
        });
        if (result.status !== "0") return;
        const processId = result.data;
        InspectionApi.update(param, processId)
          .then((res) => {
            if (res.status == 0) {
              message.success("编辑成功");
              handelCancel(true);
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      } else {
        InspectionApi.add(param)
          .then(async (res) => {
            if (res.status == 0) {
              const process = await sysApi.getFlowableId({
                dictType: "sw-flowable",
                dictKey: "patrol_template_status_enable",
              });
              if (process.status !== "0") return;
              const processId = process.data;
              const result = await InspectionApi.enable({
                id: res.data,
                processId,
              });
              if (result.status !== "0") return;
              message.success("新增成功");
              handelCancel(true);
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    });
  };
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  };

  // 切换类型
  const changeTmpType = (value) => {
    const idx = templateList.findIndex((item) => item.value == value);
    if (idx > -1) {
      setTmpType(templateList[idx].disName);
    }
  };

  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button
            key={1}
            onClick={() => handelCancel(false)}
            className="abuttons"
          >
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          {formData && !formData.disable && (
            <Button
              key={2}
              loading={loading}
              onClick={submit}
              className="abuttons"
              type="primary"
            >
              <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
            </Button>
          )}
        </Row>,
      ]}
      visible={visible}
      width={1000}
      okText={"确定"}
      onCancel={() => handelCancel(false)}
      onSubmit={submit}
      forceRender
    >
      <div className="userModal">
        <Form {...layout} form={form} style={{ marginTop: "20px" }}>
          <Form.Item
            label="模板名称"
            name="templateName"
            rules={[{ required: true, message: "请输入模板名称" }]}
          >
            <Input placeholder={"请输入模板名称"} />
          </Form.Item>
          <Form.Item
            label="模板类型"
            name="templateType"
            rules={[{ required: true, message: "请输入模板类型" }]}
          >
            <Select disabled placeholder="请选择模板类型" onChange={changeTmpType}>
              {templateList.map((item) => {
                return (
                  <Select.Option value={item.value} key={item.id}>
                    {item.disName}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.List name="patrolTemplateItems">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Row gutter={16} key={field.key} style={{ marginBottom: 20 }}>
                    <Col span={8}>
                      <Form.Item
                        label="巡检内容"
                        labelCol={4}
                        name={[field.name, "itemContent"]}
                        rules={[{ required: true, message: "请填写巡检项!" }]}
                      >
                        <Input.TextArea row={4} placeholder={"巡检内容"} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      {(tmpType === "设备人员模板" ||
                        tmpType === "操作人员模板") && (
                        <Form.Item
                          labelCol={4}
                          layout="horizontal"
                          label="填写数值类"
                          name={[field.name, "numericFlag"]}
                          rules={[
                            { required: true, message: "是否填写数值类!" },
                          ]}
                        >
                          <Radio.Group>
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={8}>
                      {(tmpType === "设备人员模板" ||
                        tmpType === "操作人员模板") && (
                        <Form.Item
                          labelCol={4}
                          layout="horizontal"
                          label="安全隐患"
                          name={[field.name, "safetyPerilFlag"]}
                          rules={[
                            {
                              required: true,
                              message: "请选择是否存在安全隐患!",
                            },
                          ]}
                        >
                          <Radio.Group>
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={8}>
                      {tmpType == "操作人员模板" && (
                        <Form.Item
                          labelCol={4}
                          label="运行状态"
                          name={[field.name, "runStatus"]}
                        >
                          <Checkbox.Group options={runStatusRange} />
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={8}>
                      {tmpType == "操作人员模板" && (
                        <Form.Item
                          labelCol={4}
                          label="缺陷等级"
                          name={[field.name, "defectLevelId"]}
                        >
                          <Select placeholder={"请选择缺陷等级"}>
                            {defectslevelLs.map((item) => {
                              return (
                                <Option value={item.id} key={item.id}>
                                  {item.defectLevelName}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={22} offset={2}>
                      {fields.length > 1 && (
                        <MinusCircleOutlined
                          onClick={() => remove(field.name)}
                        />
                      )}
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()}>
                    添加
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </div>
    </AddModal>
  );
};
